import * as React from 'react';

import classnames from 'classnames';

import type { TaskResponse } from 'common/components/TasksWidget/queries';
import { TaskStatus } from 'common/components/TasksWidget/queries';
import TopBarDropdownMenuItem from 'common/components/TopBarDropdownMenu/TopBarDropdownMenuItem/TopBarDropdownMenuItem';

import useTaskItem from './useTaskItem';

export type TaskItemProps = {
  task: TaskResponse;
  className?: string;
  onTaskDismiss: (task: TaskResponse) => void;
};

export const TASK_TERMINATED_STATUSES = [TaskStatus.DONE, TaskStatus.CANCELLED, TaskStatus.FAILED];

export default function TaskItem(props: TaskItemProps) {
  const { handleDismiss, goToTaskInfo, dismissLoading, showDismissButton, owner } = useTaskItem(props);

  const className = classnames('task-item', props.className);

  return (
    <TopBarDropdownMenuItem
      status={props.task.status}
      className={className}
      content={<p className="mb-xxs">{props.task.displayName}</p>}
      time={props.task.startTime}
      onActionClick={handleDismiss}
      handleItemClick={goToTaskInfo}
      showAction={!dismissLoading && showDismissButton}
      owner={owner}
    />
  );
}
